<template>
  <EditDialog
    v-model:visible="showModal"
    :title="
      $t('views.layout.Dialog.BindEmail.5667b5297465f5ac17615ae0867b8bb1')
    "
    :width="595"
    :mask-closable="false"
    :sure-btn-text="
      $t('views.layout.Dialog.BindEmail.c47608d1c7fa530152ac4a1da2b6e5ab')
    "
    :sure-btn-width="435"
    :loading="loading"
    @after-visible-change="clear"
    @submit="checkForm"
  >
    <div class="dialog-body">
      <div class="tips">
        {{
          $t('views.layout.Dialog.BindEmail.4ccd2eb00682ac72d3b6c4fc7a278373')
        }}
      </div>
      <DynamicsForm
        ref="formRef"
        style="width: 435px"
        :model="formModel"
        :setting="setting"
        tips-placement="right"
        @keyup.enter="checkForm"
      >
        <template #verify_code>
          <div class="verify-code-wrap">
            <u-input
              v-model="formModel.verify_code"
              style="margin-right: 12px; width: 285px"
              :placeholder="
                $t(
                  'views.layout.Dialog.BindEmail.8ed7949c0b7604c7eddab63f398a567e'
                )
              "
              :maxlength="6"
            />
            <VerifyCodeBtn
              mode="email"
              verify-type="bind_mail"
              :email="formModel.email"
            />
          </div>
        </template>
      </DynamicsForm>
    </div>
  </EditDialog>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { defineComponent, ref, reactive } from 'vue';
import { useStore } from 'vuex';
import { message } from '@koi-design/uxd-ui';
import { DynamicsForm } from '@koi-design/vix-components';
import VerifyCodeBtn from '@/components/VerifyCodeBtn.vue';
import { emailReg } from '@/libs/reg';
import { bindEmailApi } from '@api/permission';

export default defineComponent({
  name: 'BindEmail',
  components: {
    DynamicsForm,
    VerifyCodeBtn
  },
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const showModal = ref(false);
    const show = flag => {
      showModal.value = flag;
    };
    const formRef = ref();
    const formModel = reactive({
      email: '',
      verify_code: ''
    });
    const setting = ref([
      {
        name: 'email',
        type: 'input',
        label: '',
        props: {
          placeholder: t(
            'views.layout.Dialog.BindEmail.7e28a2e7047530a6e41187ac19c06934'
          ),
          maxlength: 32
        }
      },
      {
        label: '',
        type: 'slot',
        slot: 'verify_code'
      }
    ]);
    const clear = visible => {
      if (!visible) {
        formModel.email = '';
        formModel.verify_code = '';
      }
    };
    const loading = ref(false);
    const handleSubmit = async () => {
      try {
        loading.value = true;
        await bindEmailApi({
          email: formModel.email,
          verify_code: formModel.verify_code
        });
        message.success(
          t('views.layout.Dialog.BindEmail.79668bd476c3de8a75ad8a1c2e3b0cf1')
        );
        const userInfo = {
          ...store.getters.botUserInfo
        };
        userInfo.email = formModel.email;
        store.commit('setUserInfo', userInfo);
        showModal.value = false;
      } catch (error) {
        const errMsg = typeof error === 'string' ? error : error.message;
        message.error(errMsg);
      } finally {
        loading.value = false;
      }
    };
    const checkForm = () => {
      if (!emailReg.test(formModel.email)) {
        message.error(
          t('views.layout.Dialog.BindEmail.4f65527fa1c87e1c92d692dc7fd5907f')
        );
        return;
      }
      if (!formModel.verify_code.trim()) {
        message.error(
          t('views.layout.Dialog.BindEmail.a1a43d25f36815331e0f711adbdb5b17')
        );
        return;
      }
      handleSubmit();
    };
    return {
      showModal,
      formRef,
      formModel,
      setting,
      loading,
      show,
      clear,
      checkForm
    };
  }
});
</script>

<style lang="less" scoped>
.dialog-body {
  .tips {
    color: var(--primary-color);
    margin-bottom: 16px;
  }
}
</style>
